import React from 'react';
import { useField } from 'formik';

import Summernote from './Summernote.jsx';

const isEmpty = (v) => [
  '<p><br></p>',
  '<br>',
].includes(v.trim());

const FieldSummernote = (props) => {
  const [, { value }, { setTouched, setValue }] = useField(props);

  return (
    <Summernote
      value={value}
      onBlur={setTouched}
      onChange={(v) => setValue(isEmpty(v) ? '' : v)}
      {...props}
    />
  );
};

export default FieldSummernote;
